/*
 * Copyright (C) 2023. PLEO Interactive sp. z o.o. All rights reserved.
 * This code and its associated files are the proprietary property of PLEO Interactive  sp. z o.o and may not be copied, modified, or distributed without written permission.
 */

import React from 'react';

function SvgCookie(props) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" id="Warstwa_1" data-name="Warstwa 1" viewBox="0 0 170 170" {...props}>
			<defs>
				<radialGradient
					id="Gradient_bez_nazwy_14"
					cx={84.97}
					cy={85}
					r={59.08}
					data-name="Gradient bez nazwy 14"
					fx={84.97}
					fy={85}
					gradientUnits="userSpaceOnUse"
				>
					<stop offset={0.43} stopColor="#0f0666" />
					<stop offset={0.51} stopColor="#1c0a78" />
					<stop offset={0.68} stopColor="#4116a9" />
					<stop offset={0.88} stopColor="#7528f0" />
				</radialGradient>
				<style>{'.cls-1{fill:#f1e300}.cls-3{fill:#00f6c2}.cls-4{fill:#924dff}'}</style>
			</defs>
			<path
				d="M0 0h170v170H0z"
				style={{
					fill: 'none',
				}}
			/>
			<circle cx={127.49} cy={44.6} r={1.37} className="cls-4" />
			<circle cx={145.16} cy={67.17} r={1.37} className="cls-4" />
			<circle cx={129.88} cy={57.35} r={2.39} className="cls-4" />
			<circle cx={147.55} cy={50.31} r={2.39} className="cls-4" />
			<circle cx={123.79} cy={97.3} r={2.08} className="cls-1" />
			<path
				d="M127.39 74.58c-7.42-.19-14.1-5.31-15.93-12.87-1.26-5.2.04-10.43 3.09-14.35-.52-1.08-.94-2.23-1.24-3.45a16.7 16.7 0 0 1 .78-10.33c-.2-.11-.39-.23-.58-.34-.32-.17-.63-.34-.95-.51-.47-.25-.95-.5-1.43-.73-.39-.19-.79-.38-1.18-.57-.43-.2-.87-.4-1.31-.59-.43-.19-.85-.37-1.28-.54-.44-.18-.88-.35-1.32-.52-.42-.16-.84-.32-1.26-.47-.49-.18-.99-.34-1.49-.5-.37-.12-.74-.24-1.11-.35-.61-.18-1.22-.36-1.84-.52-.26-.07-.53-.15-.79-.21-.81-.21-1.64-.4-2.46-.57-.07-.01-.14-.03-.21-.05a59.412 59.412 0 0 0-17.8-.89l-.54.06c-.73.08-1.45.17-2.17.28-.5.07-1 .16-1.5.25-.4.07-.8.14-1.19.21-.71.14-1.41.29-2.12.46-.2.05-.4.09-.6.14-.86.21-1.72.44-2.56.69-.1.03-.19.05-.29.08-.86.26-1.71.54-2.55.83-.1.04-.21.07-.31.1-.78.28-1.54.57-2.3.88-.17.07-.35.14-.53.21-.64.26-1.27.55-1.9.83-.29.13-.58.25-.86.39-.47.22-.93.46-1.39.7-.43.22-.86.43-1.28.65-.28.15-.56.32-.84.48-.58.33-1.16.65-1.73.99-.1.06-.19.12-.28.18a59.087 59.087 0 0 0-10.88 8.58c-.17.17-.34.36-.51.53-.47.48-.94.97-1.4 1.46a59.351 59.351 0 0 0-14.57 29.85c-.03.18-.07.35-.09.53-.1.62-.18 1.25-.26 1.88-.05.38-.1.75-.14 1.13-.05.49-.09.99-.13 1.48-.04.51-.09 1.02-.12 1.53-.03.44-.04.88-.05 1.33-.02.55-.04 1.1-.04 1.65 0 .5 0 .99.02 1.49 0 .46.02.93.04 1.39.03.66.07 1.32.12 1.98l.06.81c.08.88.18 1.76.3 2.65 0 .04 0 .07.01.11a59.463 59.463 0 0 0 6.29 19.6c.05.09.09.19.14.28.32.61.67 1.2 1.01 1.79.16.27.31.55.47.82.23.38.47.75.71 1.12.29.46.58.92.88 1.37.11.16.22.31.33.47 2.59 3.76 5.59 7.2 8.95 10.26.29.26.58.51.87.76.41.35.81.71 1.22 1.06a59.337 59.337 0 0 0 19.58 10.72c.08.03.16.06.25.08.58.19 1.18.35 1.77.52.37.1.74.22 1.12.32.35.09.7.17 1.05.25.63.15 1.26.31 1.9.44.14.03.28.05.42.08 3.74.74 7.61 1.14 11.57 1.14 1.98 0 3.94-.1 5.86-.29.2-.02.4-.04.59-.07a51.9 51.9 0 0 0 2.18-.28c.41-.06.82-.13 1.23-.2.52-.09 1.04-.18 1.55-.28.57-.11 1.15-.24 1.72-.37.39-.09.78-.17 1.16-.27.44-.11.87-.23 1.3-.34.46-.13.92-.25 1.38-.39.39-.12.78-.24 1.16-.36.55-.18 1.09-.36 1.63-.55.27-.1.55-.19.82-.29 13.45-5 24.59-14.75 31.36-27.22 0-.01.01-.02.02-.03 4.22-7.77 6.73-16.61 7.07-25.99-7.63.17-14.63-4.91-16.63-12.58Zm-42.35 32.55c-12.08 0-21.87-9.79-21.87-21.87s9.8-21.87 21.87-21.87 21.87 9.79 21.87 21.87-9.8 21.87-21.87 21.87Z"
				style={{
					fill: 'url(#Gradient_bez_nazwy_14)',
				}}
			/>
			<path
				d="M127.4 74.6c-7.42-.19-14.1-5.31-15.93-12.87-1.26-5.2.04-10.43 3.09-14.35-.52-1.08-.94-2.23-1.24-3.45-.87-3.58-.52-7.18.79-10.35-12.61-7.12-27.83-9.68-43.01-6-31.72 7.69-51.2 39.63-43.51 71.36a59.08 59.08 0 0 0 3.96 11.26c3.38-3.95 8.4-6.46 14.01-6.46 10.18 0 18.43 8.25 18.43 18.43v5.41c0 6.58 5.33 11.91 11.91 11.91s11.91-5.33 11.91-11.91v-1.93c0-5.55 4.5-10.05 10.05-10.05 3.76 0 7.05 2.07 8.77 5.13.8 1.41 1.16 3.03 1.2 4.65l.09 4.78c0 2.14 1.74 3.88 3.88 3.88s3.88-1.74 3.88-3.88v-7.02c0-6.14 4.98-11.11 11.11-11.11 3.43 0 6.5 1.56 8.54 4.01 5.29-8.58 8.4-18.5 8.78-28.85-7.66.19-14.68-4.89-16.69-12.58Zm-42.35 32.55c-12.08 0-21.87-9.79-21.87-21.87s9.8-21.87 21.87-21.87 21.87 9.79 21.87 21.87-9.8 21.87-21.87 21.87Z"
				className="cls-4"
			/>
			<circle cx={44.34} cy={78.28} r={2.08} className="cls-1" />
			<circle cx={99.24} cy={57.04} r={2.08} className="cls-1" />
			<circle cx={69.07} cy={54.96} r={2.08} className="cls-1" />
			<circle cx={75.99} cy={118.76} r={2.08} className="cls-1" />
			<circle cx={100.18} cy={39.64} r={2.08} className="cls-1" />
			<path
				d="m96.2 111.5-.49-1.15A27.472 27.472 0 0 0 112.51 85c0-.75-.03-1.51-.09-2.24l1.25-.1c.06.77.09 1.56.09 2.35 0 11.59-6.9 21.99-17.57 26.5ZM33.68 70.92l-1.21-.33A54.491 54.491 0 0 1 66.68 33.7l.42 1.18c-16.35 5.84-28.85 19.31-33.42 36.04ZM32.34 98.9A54.523 54.523 0 0 1 30.55 85c0-3.84.4-7.68 1.2-11.4l1.22.26C32.19 77.5 31.8 81.25 31.8 85c0 4.6.59 9.17 1.75 13.58l-1.21.32Z"
				className="cls-3"
			/>
		</svg>
	);
}

export default SvgCookie;
